import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

// LAYOUT COMPONENTS
import Navbar from '../components/Layout/Navbar'
import { useLocation } from 'react-router-dom';


const FramePage = (props) => {
  //agent id
  const agentID = useSelector(state => state.viewFromAgentId)

  //url path param
  const {type} = props.match.params

  //state from dynamicLinks in navbar.js
  const location = useLocation()
  const { state } = location
  const title = state?.name //page title

  //iframe url
  const url = `${process.env.REACT_APP_IPROFORMA_MAIN_PAGE}/app.html?agentId=${agentID}&type=${type}`;

  
  useEffect(()=> {   
    // console.log(location)
    // console.log(type)
  }, [])

  return (
    <div className='layout frame'>
      <Navbar title={ title } />

      <div className='content-wrapper'>
        <div className='scrollable'>
          <div className='content'>
            <iframe
              title="Embedded Page"
              width="100%"
              height="100%"
              src={url}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FramePage